import { defineComponent, ref, onMounted } from 'vue';
import { db } from '@/firebase'; // Adjust the import based on your firebase configuration
import { collection, getDocs } from 'firebase/firestore';
export default defineComponent({
    name: 'ProductList',
    setup() {
        const products = ref([]);
        const fetchProducts = async () => {
            const snapshot = await getDocs(collection(db, 'products'));
            products.value = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        };
        const addToCart = (product) => {
            console.log(`Added ${product.name} to cart`);
        };
        onMounted(() => {
            fetchProducts();
        });
        return {
            products,
            addToCart,
        };
    },
});
